<template>
	<div class="user_feedback_detail clearfix p_background">
		<h3 class="all_title clearfix">
			<span>用户反馈</span>
			<router-link to="/feedback_list" class="pull-right cursor color_9 th3">返回</router-link>
		</h3>

		<section class="all_container container_box">

			<div class="detail">
				<section class="title th2 color_6">反馈内容</section>
				<section class="content">
					<div class="top clearfix color_9 clearfix">
						<span class="item">
							反馈人：{{feedback.schoolcloudUserUsername}}
						</span>
						<span class="item text-center">
							反馈类型：
							<span v-if="feedback.feedbackType == '1'">平台反馈</span>
							<span v-if="feedback.feedbackType == '2'">意见建议</span>
							<span v-if="feedback.feedbackType == '3'">应用反馈<span v-if="feedback.appName != null">-{{feedback.appName}}</span></span>
						</span>
						<span class="item text-right">
							反馈时间：{{feedback.feedbackTime | datetime}}
						</span>
					</div>
					<div class="bottom">
						<section class="text_show color_9">
							{{feedback.feedbackComment}}
						</section>
						<section class="imgFile color_308de2" v-if="feedbackFiles != null">
							<img :src="feedbackFiles.filePath" alt="反馈图片"/>
						</section>
					</div>
				</section>
			</div>

			<div class="detail">
				<section class="title th2 color_6">反馈回复</section>
				<section class="content">
					<div class="top clearfix color_9">
						<span class="left pull-left">
							变更反馈类型：{{feedback.remark}}
						</span>
						<span class="right pull-right">
							回复时间：{{feedback.answerTime | datetime}}
						</span>
					</div>
					<div class="bottom">
						<section class="text_show color_9">
							{{feedback.answerComment}}
						</section>
					</div>
				</section>
			</div>

		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				feedbackId: this.$route.params.feedbackId,
				feedback:'',
				feedbackFiles:[]
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		// 页面初始化
		created: function() {
			this.initData();
		},
		methods: {
			initData() {
				var _this = this;
				this.$http.post('/zklccloud/queryFeedbackInfoById', { "id": this.feedbackId}, { emulateJSON: true }).then(function(m) {
					_this.feedback = m.body.content.feedback;
					_this.feedbackFiles = m.body.content.feedbackFiles;
				})
			},
		}
	}
</script>

<style scoped>
	.title {
		padding: 15px 0;
	}
	
	.content {
		border: 1px dashed #ccc;
		margin-bottom: 15px;
	}
	
	.top {
		padding: 10px 15px;
		border-bottom: 1px dashed #ccc;
	}
	
	.top .item {
		float: left;
		width: 25%;
	}
	
	.bottom {
		padding: 10px 15px;
	}
	
	.text_show {
		min-height: 120px;
		margin-bottom: 15px;
	}
	
	.imgFile {
		width: 100%;
	}
	
	.imgFile img {
		max-width: 100%;
	}
</style>


// WEBPACK FOOTER //
// detail.vue?13cee06a